"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToasterProvider = exports.ToasterContext = exports.Toast = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _toastReducer = _interopRequireWildcard(require("./toastReducer"));

var _ToastPortal = _interopRequireDefault(require("./ToastPortal"));

var _index = require("./index.styles");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var ToasterContext = /*#__PURE__*/_react["default"].createContext();
/**
 * Use a Toast for global feedback.
 *
 * A Toast is based on the `Alert` component, which is intended for local feedback.
 *
 * Initialise the toaster by setting `ToasterProvider` high up the React tree.
 * To show a toast, either use the `showToast()` function provided by the `ToasterContext`
 * or the `<Toast />` component in your jsx.
 */


exports.ToasterContext = ToasterContext;

var ToasterProvider = function ToasterProvider(_ref) {
  var rootSelector = _ref.rootSelector,
      children = _ref.children;

  var createRandomId = function createRandomId() {
    return Math.random().toString(36).slice(2);
  };

  if ((0, _react.useContext)(ToasterContext) !== undefined) {
    console.warn('It looks like you are nesting ToasterProviders. Please use only one.');
  }

  var toasterRootDiv = document.createElement('div');
  toasterRootDiv.setAttribute('id', 'toaster-root');
  var refToasterRoot = (0, _react.useRef)(toasterRootDiv);
  var isMounted = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  /**
   * Insert `toaster-root` into DOM above `react-root` so when focus is reset (new page),
   * the first tabbable items will be the toasts.
   * Note: focus is not managed by this component.
   */

  (0, _react.useEffect)(function () {
    var toasterDiv = refToasterRoot.current;
    var rootEl = document.querySelector(rootSelector);
    rootEl.parentElement.insertBefore(toasterDiv, rootEl);
    return function () {
      return toasterDiv.remove();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // Externalizing state using reducer causes toastMap to stay actual between instances

  var _useReducer = (0, _react.useReducer)(_toastReducer["default"], new Map()),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      toastMap = _useReducer2[0],
      dispatch = _useReducer2[1];
  /**
   * Used internally to remove Toast on click or timeout
   */


  var handleRemoveToast = function handleRemoveToast(key) {
    if (isMounted.current) {
      dispatch({
        type: _toastReducer.REMOVE_TOAST,
        key: key
      });
    }
  };
  /**
   * Immediately show a Toast
   *
   * @param   {[string]}  title    Title will be bold text
   * @param   {[node]}    body     Usually a string, but can be any valid react node
   * @param   {[string]}  variant  See `Alert` component for variants. Defaults to info
   * @param   {[number]}  delay    Milliseconds to wait before showing
   *
   * @return  void
   */


  var showToast = function showToast(_ref2) {
    var title = _ref2.title,
        body = _ref2.body,
        variant = _ref2.variant,
        _ref2$delay = _ref2.delay,
        delay = _ref2$delay === void 0 ? 0 : _ref2$delay;
    var action = {
      type: _toastReducer.ADD_TOAST,
      key: createRandomId(),
      toast: {
        title: title,
        variant: variant,
        children: body
      }
    };

    if (delay) {
      setTimeout(function () {
        return dispatch(action);
      }, delay);
    } else {
      dispatch(action);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(ToasterContext.Provider, {
    value: {
      showToast: showToast
    }
  }, /*#__PURE__*/_react["default"].createElement(_index.ToasterRootStyle, null), /*#__PURE__*/_react["default"].createElement(_ToastPortal["default"], {
    refToasterRoot: refToasterRoot,
    toastMap: toastMap,
    onRemoveToast: handleRemoveToast
  }), children);
};

exports.ToasterProvider = ToasterProvider;
ToasterProvider.propTypes = {
  rootSelector: _propTypes.string,
  children: _propTypes.node
};
ToasterProvider.defaultProps = {
  rootSelector: '#root'
};
/**
 * Helper component to show Toast from jsx
 * Same props as params for `showToast`
 */

var Toast = function Toast(props) {
  var _useContext = (0, _react.useContext)(ToasterContext),
      showToast = _useContext.showToast;

  (0, _react.useEffect)(function () {
    showToast(_objectSpread({}, props));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

exports.Toast = Toast;